module.exports = __webpack_public_path__ + "img/cadastro_xp_ontick-02.52989c64.png";